import { CR_SUBMISSION } from '../constants';

export type ScoresSelectionInitParams = {
    rootElement: Pick<HTMLElement, 'querySelectorAll'>;
};
export const init5ScaleRatingSelections = ({ rootElement }: ScoresSelectionInitParams): void => {
    const scoreSelectionElements = Array.from(rootElement.querySelectorAll('.js_cr_5-scale-radio-button-selection'));
    scoreSelectionElements.forEach(scoreSelectionElement => {
        const resetButtonElement = scoreSelectionElement.querySelector('.js_cr_5-scale-radio-button-selection__reset-button');
        const valueNameElement = scoreSelectionElement.querySelector<HTMLElement>('.js_cr_5-scale-radio-button-selection__value-name');
        const defaultValueName = scoreSelectionElement.getAttribute('data-default-value-name');
        const inputElements = Array.from(
            scoreSelectionElement.querySelectorAll<HTMLInputElement>('.js_cr_5-scale-radio-button-selection__input')
        );

        resetButtonElement?.addEventListener('click', () => {
            inputElements.forEach(inputElement => (inputElement.checked = false));
            resetButtonElement?.classList.add(CR_SUBMISSION.STAR_RATING.ERROR_BANNER_HIDDEN_CLASS);
            if (valueNameElement !== null && defaultValueName !== null) {
                valueNameElement.innerText = defaultValueName;
            }
        });

        inputElements.forEach(inputElement =>
            inputElement.addEventListener('click', () => {
                resetButtonElement?.classList.remove(CR_SUBMISSION.STAR_RATING.ERROR_BANNER_HIDDEN_CLASS);
                const valueName = inputElement.dataset.valueName;
                if (valueNameElement !== null && valueName !== undefined) {
                    valueNameElement.innerText = valueName;
                }
            })
        );
    });
};
